<img class="inline mr-2" src="../../../assets/img/ic-last-access.svg" />
<div class="inline text-neutral-600 text-xs font-normal font-['Inter'] leading-7">Último ingreso: {{login}} Hrs.</div>